export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://api-test.plankerp.com/api',
  mockApi: false
};
